import { keyframes, styled } from "goober";
import { useEffect, useState } from "react";
import { ToastCard } from "./Toast";

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-6px);
  }
`;

// Floats over the top of the message viewport (a position:relative container)
// so the feed never reflows on appear/dismiss; only the card takes pointer
// events, leaving its margins scroll-through.
const Overlay = styled("div")`
  position: absolute;
  top: 0;
  left: -12px;
  right: -12px;
  padding: 8px 8px 4px;
  pointer-events: none;
  z-index: 1;

  &.entering {
    animation: ${slideIn} 240ms cubic-bezier(0.22, 0.68, 0.35, 1.05);
  }
  &.exiting {
    animation: ${slideOut} 240ms cubic-bezier(0.22, 0.68, 0.35, 1.05) forwards;
  }
`;

const CardHolder = styled("div")`
  pointer-events: auto;
`;

export function BranchLiveNudge({
  show,
  onGoLive,
}: {
  show: boolean;
  onGoLive: () => void;
}) {
  const [rendered, setRendered] = useState(show);
  useEffect(() => {
    // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
    if (show) setRendered(true);
  }, [show]);
  if (!rendered) return null;
  return (
    <Overlay
      className={show ? "entering" : "exiting"}
      onAnimationEnd={(e) => {
        if (e.currentTarget === e.target && !show) setRendered(false);
      }}
    >
      <CardHolder>
        <ToastCard
          fullWidth
          icon="info"
          message="You’re viewing a branch"
          buttonLabel="Go to live"
          onButtonClick={onGoLive}
        />
      </CardHolder>
    </Overlay>
  );
}
